<div *ngFor="let document of relatedDocuments; trackBy: trackByDocumentNumber" class="mt-1">
    <em class="pi pi-external-link blue-color cursor-pointer" (click)="loadDocumentDetails(document.number, document.version)"></em>
    <span>
      <a class="ml-3 underline blue-color cursor-pointer overflow-ellipse" (click)="loadDocumentDetails(document.number, document.version)">
        {{ document.number }} {{ document.title }}
      </a>
    </span>
  </div>
  